import React from 'react';
import { components } from 'react-select';

const CustomIndicator = React.memo((props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                {props.selectProps?.dropDownIcon}
            </components.DropdownIndicator>
        )
    );
});

CustomIndicator.displayName = 'CustomIndicator';

export default CustomIndicator;
